import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaCodificacion from "./tablaCodificacion";
import CatalogoProveedorPresupuesto from "../../catalogos/catalogoProveedorm";
import CatalogoUnidadEjecutora from "../../catalogos/catalogoUnidadEjecutora";
import CatalogoOrdenesdeComprasAprob from "../../catalogos/catalogoOrdenesdeCompraAprob";
import CatalogoSPagoNomiAprob from "../../catalogos/catalogoSPagoNomiAprob";
import CatalogoFondoAvanceAprob from "../../catalogos/catalogoFondoAvanceAprob";
import CatalogoObrasAsignada from "../../catalogos/catalogoObrasAsignada";
import { validaSoloNumero, formatMoneda } from "../../util/varios";
import ValidarUsuario from "../comun/modalValidarUsuario";
import { CambiodeDatos } from "../comun/modalCambiodDatos";

import {
  DangerButton,
  WarningButton,
  PrimaryButton,
  SuccessButton,
} from "../../ui/buttons/Button.jsx";

import {
  Input,
  Select,
  Radio,
  Textarea,
  SearchInput,
} from "../../ui/inputs/Input.jsx";

export const Compromisos = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const anioefis = JSON.parse(localStorage.getItem("efiscalanio"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const ip = JSON.parse(localStorage.getItem("ip"));
  const mac = JSON.parse(localStorage.getItem("mac"));
  const liquidador = JSON.parse(localStorage.getItem("liquidador"));
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habiCod, setHabicod] = useState(true);
  const [habicat, setHabicat] = useState(true);
  const [habicatb, setHabicatb] = useState(true);
  const [habiProv, setHabiProv] = useState(false);
  const [habiUni, setHabiUni] = useState(false);
  const [habiConcep, setHabiConcep] = useState(false);
  const [habiFecha, setHabiFecha] = useState(false);
  const [habitipoc, setHabitipoc] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [condicion, setCondicion] = useState([]);
  const [valida, setValida] = useState(0);
  const [validat, setValidat] = useState(0);
  const [val, setVal] = useState(0.0);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [mostrar6, setMostrar6] = useState(false);
  const [mostrar7, setMostrar7] = useState(false);
  const [mostrar8, setMostrar8] = useState(false);
  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [montoCompro, setMontoCompro] = useState(0.0);
  const [montoIva, setMontoIva] = useState(0.0);
  const [deshabi, setDeshabi] = useState(true);
  const [vt, setVt] = useState(0);
  const [modifi, setModifi] = useState(false);
  const [proce, setProce] = useState(false);
  const [cat, setCat] = useState(0);
  const [tipo, setTipo] = useState(0);
  const [data, setData] = useState([]);
  const [cambioDatos, setCambioDatos] = useState(false);
  const [body, setBody] = useState(null);
  const [codigo, setCodigo] = useState(0);
  const [validatipo, setValidatipo] = useState(0);
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const [ultimo, setUltimo] = useState(false);
  const [estatus, setEstatatus] = useState(1);
  const [tipoOrden, setTipoOrden] = useState(0);
  const [exento, setExento] = useState(false);
  const [desde, setDesde] = useState(0);
  const [idPreComp, setIdPreComp] = useState(0);
  const [monaCompro, setMonaCompro] = useState(0.0);
  const [fecha, setFecha] = useState(null);
  const [fechaRev, setFechaRev] = useState(null);
  const [llamado, setLlamado] = useState(0);
  const [cambiarDatos, setCambiarDatos] = useState(false);
  const [fechaRef, setFechaRef] = useState(null);
  const txtCodigo = useRef();
  const txtFecha = useRef();
  const txtFechaAprobacion = useRef();
  const txtFechaReverso = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtNombreOr = useRef();
  const txtNTraslado = useRef();
  const txtIdprov = useRef();
  const txtCedurifprov = useRef();
  const txtNombreprov = useRef();
  const txtIdCoordinacion = useRef();
  const txtNombreUnidad = useRef();
  const txtTipoCompromiso = useRef();
  const txtReferencia = useRef();
  const txtConcepto = useRef();
  const txtMontoComprometer = useRef();
  const txtMontoFondo = useRef();

  const onChange = (e) => {
    if (
      e.target.name === "descriaux" ||
      e.target.name === "ubicacion" ||
      e.target.name === "concepto" ||
      e.target.name === "observacion"
    ) {
      e.target.value = e.target.value.toUpperCase();
    }

    if (e.target.name === "tipo") {
      txtConcepto.current.value = "";
      txtObservacion.current.value = "";
      txtIdCoordinacion.current.value = "";
      txtNombreUnidad.current.value = "";
      txtIdprov.current.value = "";
      setExento(false);
      txtCedurifprov.current.value = "";
      txtNombreprov.current.value = "";
      txtMontoComprometer.current.value = "0,00";
      setMonaCompro(0.0);
      txtReferencia.current.value = "";
      setDeshabilitado(false);
      /*setHabiprov(false);*/
      setDatospre([]);
      setIdPreComp(0);
      if (e.target.value === "1") {
        setChek(1);
        setHabicat(false);
        setHabicatb(false);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        setValidatipo(e.target.value);
        setTipo(5); // ORDEN DE COMPRA
        setTipoOrden(0);
        setEstatatus(1);
        setDeshabi(true);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "2") {
        setChek(2);
        setValidatipo(e.target.value);
        setHabicat(false);
        setHabicatb(false);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        setTipo(7); // PAGO DE OBRAS
        setDeshabi(true);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "3") {
        setChek(3);
        setValidatipo(e.target.value);
        setTipo(11); // ORDEN DE SERVICIO
        setHabicat(false);
        setHabicatb(false);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        setTipoOrden(1);
        setEstatatus(1);
        setDeshabi(true);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "4") {
        setChek(4);
        setTipo(12); // PAGO DIRECTO
        setValidatipo(e.target.value);
        setHabicat(true);
        setHabicatb(true);
        setHabiProv(false);
        setHabiUni(false);
        setHabiConcep(false);
        setDeshabi(false);
        setDeshabilitado(false);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "5") {
        setChek(5);
        setTipo(13); // PAGO DE NOMINA
        setValidatipo(e.target.value);
        setHabicatb(false);
        setHabicat(false);
        setHabiProv(false);
        setHabiUni(false);
        setHabiConcep(true);
        setDeshabi(false);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "6") {
        setChek(6);
        setTipo(23); // FONDO EN AVANCE
        setValidatipo(e.target.value);
        setHabicatb(false);
        setHabicat(false);
        setDeshabi(true);
        setHabiProv(true);
        setHabiConcep(false);
        setHabiUni(false);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "7") {
        setChek(7);
        setTipo(24); // FONDO EN ANTICIPO
        setValidatipo(e.target.value);
        setHabicatb(false);
        setHabicat(false);
        setDeshabi(true);
        setHabiUni(false);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "8") {
        setChek(8);
        setValidatipo(e.target.value);
        setHabicat(true);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        setDeshabi(true);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "9") {
        setChek(9);
        setTipo(26); // ORDEN DE DONACION
        setValidatipo(e.target.value);
        setHabicat(false);
        setHabicatb(false);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        setTipoOrden(2);
        setEstatatus(1);
        setDeshabi(true);
        //txtReferencia.current.value = '';
      } else {
        setHabicat(true);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        //txtReferencia.current.value = '';
      }
    } else if (e.target.name === "referencia") {
      txtConcepto.current.value = "";
      txtObservacion.current.value = "";
      txtIdCoordinacion.current.value = "";
      txtNombreUnidad.current.value = "";
      txtIdprov.current.value = "";
      setExento(false);
      txtCedurifprov.current.value = "";
      txtNombreprov.current.value = "";
      txtMontoComprometer.current.value = "0,00";
      setMonaCompro(0.0);
      if (txtMontoFondo && txtMontoFondo.current) {
        txtMontoFondo.current.value = "0,00";
      }

      /*setDeshabilitado(false);
            setHabiprov(false);*/
      setDatospre([]);
    }
  };

  const handleReferencia = (e) => {
    validaSoloNumero(event);
    if (e.which === 13 || typeof e.which === "undefined") {
      txtFecha.current.focus();
      if (e.target.value !== "") {
        if (validatipo === "1") {
          seleccionarOrdenCompra(e.target.value, props.operacion, tipo);
        } else if (validatipo === "2") {
          seleccionarSolicitudPagoObra(e.target.value, props.operacion);
        } else if (validatipo === "3") {
          seleccionarOrdenCompra(e.target.value, props.operacion, tipo);
        } else if (validatipo === "5") {
          seleccionarSPagoNomina(e.target.value, props.operacion);
        } else if (validatipo === "6") {
          seleccionarFondoAvance(e.target.value, props.operacion);
        } else if (validatipo === "7") {
          seleccionarFondoAvance(e.target.value, props.operacion);
        } else if (validatipo === "9") {
          seleccionarOrdenCompra(e.target.value, props.operacion, tipo);
          //seleccionarOrdenDonacion(e.target.value);
        }
      }
    }
  };

  const seleccionarReferencia = (tip, ope) => {
    let sigue = false;
    setFechaRef(null);
    switch (tip) {
      case 5:
      case 11:
      case 26:
        seleccionarOrdenCompra(txtReferencia.current.value, ope, tip);
        break;
      case 7:
        seleccionarSolicitudPagoObra(txtReferencia.current.value, ope);

        break;
      case 13:
        seleccionarSPagoNomina(txtReferencia.current.value, ope);

        break;
      case 23:
        seleccionarFondoAvance(txtReferencia.current.value, ope);

        break;
      /*case 24:
                lblTipo.setText("Monto Fondo Anticipo");
                sigue = seleccionarFondoAvance(bloq);
                if (sigue) {
                    btnAgregar1.setEnabled(true);
                    btnEliminar1.setEnabled(true);
                }
                break;
            case 26:
1                sigue = seleccionarOrdenDonacion(bloq);
                if (sigue) {
                    if (idPreComp == 0) {
                        btnAgregar1.setEnabled(true);
                        btnEliminar1.setEnabled(true);
                    } else {
                        btnAgregar1.setEnabled(false);
                        btnEliminar1.setEnabled(false);
                    }
                    if (props.operacion == 1) {
                        txtIdCoordinacion.current.value = response.data.idcoordinacion;
                        //Event evt = new Event();
                        //evt.keyCode = SWT.CR;
                        //txtIdCoordinacion.notifyListeners(SWT.KeyUp, evt);
                    }


                }
                break;*/
    }
  };

  const seleccionarOrdenCompra = (id, ope, tip) => {
    setActivate(true);
    let nomid = "";
    if (tip === 26) {
      nomid = "idordendonacion";
    } else {
      /* nomid =
        espiritu == 8 ||
        espiritu == 9 ||
        espiritu == 12 ||
        espiritu == 14 ||
        espiritu == 15
          ? tip === 5
            ? "idordencompra"
            : "idordenservicio"
          : "idordencompra"; */
      nomid = tip === 5
        ? "idordencompra"
        : "idordenservicio";
    }

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarordencompra?idefi=${idefiscal}&operacion=${ope}&nomid=${nomid}&referencia=${id}&espiritu=${espiritu}&tipo=${tipo}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setIdPreComp(response.data[0].idprecompro);
            setFechaRef(response.data[0].fecrefe);
            /*btnAgregar1.setEnabled(true);
                    btnEliminar1.setEnabled(true);*/
            if (ope === 1) {
              if (response.data[0].idcuenta > 0) {
                setDeshabi(true);
                setValida(1);
              } else {
                setDeshabi(false);
                setValida(0);
              }
              txtIdCoordinacion.current.value = response.data[0].idcordinacion;
              seleccionarUnidadEjecutora(response.data[0].idcordinacion);
              txtIdprov.current.value = response.data[0].idproveedor;
              seleccionarProveedor(response.data[0].idproveedor, 0);
              txtObservacion.current.value =
                response.data[0].observaciones === null
                  ? ""
                  : response.data[0].observaciones.trim();
              txtConcepto.current.value = response.data[0].concepto.trim();
              setDeshabilitado(true);
              setHabiProv(true);
              setHabiUni(true);
              setHabiConcep(true);
              txtMontoComprometer.current.value = formatMoneda(
                response.data[0].nmonacomprometer
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              setMonaCompro(response.data[0].nmonacomprometer);
              setDatospre(response.data);
              setMontoIva(response.data[0].montoiva);
              //setIdPreComp(response.data[0].idprecompro);
              //Event evt = new Event();
              //evt.keyCode = SWT.CR;
              //txtIdCoordinacion.notifyListeners(SWT.KeyUp, evt);
            }
          } else {
            txtReferencia.current.value = "";
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        txtReferencia.current.value = "";
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarSolicitudPagoObra = (id, ope) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarpagoobra?idefi=${idefiscal}&operacion=${ope}&referencia=${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            //setFechaRef(response.data[0].fecrefe);
            if (ope === 1) {
              if (response.data[0].idcuenta > 0) {
                setDeshabi(true);
                setValida(1);
              } else {
                setDeshabi(false);
                setValida(0);
              }
              txtIdprov.current.value = response.data[0].idproveedor;
              seleccionarProveedor(response.data[0].idproveedor, 0);
              txtConcepto.current.value = response.data[0].concepto.trim();
              setDeshabilitado(true);
              setHabiProv(true);
              setHabiUni(false);
              setHabiConcep(true);
              txtMontoComprometer.current.value = formatMoneda(
                response.data[0].nmonacomprometer
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              setMonaCompro(response.data[0].nmonacomprometer);
              setDatospre(response.data);
              setMontoIva(response.data[0].montoiva);
              //setIdPreComp(response.data[0].idprecompro);
              //Event evt = new Event();
              //evt.keyCode = SWT.CR;
              //txtIdCoordinacion.notifyListeners(SWT.KeyUp, evt);
            }
          } else {
            txtReferencia.current.value = "";
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        txtReferencia.current.value = "";
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarSPagoNomina = (id, ope) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarpagonomina?idefi=${idefiscal}&operacion=${ope}&referencia=${id}&espiritu=${espiritu}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            //setIdPreComp(response.data[0].idprecompro);
            setFechaRef(response.data[0].fecrefe);
            if (ope === 1) {
              if (response.data[0].idcuenta > 0) {
                setDeshabi(true);
                setValida(1);
              } else {
                setDeshabi(false);
                setValida(0);
              }

              //txtObservacion.current.value = response.data[0].observaciones;
              txtConcepto.current.value = response.data[0].concepto.trim();
              setDeshabilitado(true);
              //setHabiprov(false);
              txtMontoComprometer.current.value = formatMoneda(
                response.data[0].nmonacomprometer
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              setMonaCompro(response.data[0].nmonacomprometer);
              setDatospre(response.data);
              setMontoIva(response.data[0].montoiva);
              //setIdPreComp(response.data[0].idprecompro);
              //Event evt = new Event();
              //evt.keyCode = SWT.CR;
              //txtIdCoordinacion.notifyListeners(SWT.KeyUp, evt);
            }
          } else {
            txtReferencia.current.value = "";
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        txtReferencia.current.value = "";
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarFondoAvance = (id, ope) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarfondoavance?idfondo=${id}&idefi=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setFechaRef(response.data.fecha);
          if (response.data !== "") {
            if (tipo === 23) {
              if (response.data.tipofondo === 1) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  //texto: "El Fondo en Avance no existe",
                  texto: "La Solicitud de Compra no existe",
                  icono: "informacion",
                });
                txtReferencia.current.value = "";
                txtReferencia.current.focus();
                return;
              }
            } else if (tipo === 24) {
              if (response.data.tipofondo === 0) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  //texto: "El Fondo en Anticipo no existe",
                  texto: "La Solicitud de Compra no existe",
                  icono: "informacion",
                });
                txtReferencia.current.value = "";
                txtReferencia.current.focus();
                return;
              }
            }
            if (ope === 1) {
              setDeshabi(false);
              setValida(0);

              txtObservacion.current.value =
                response.data.descripcion === null
                  ? ""
                  : response.data.descripcion.trim();
              //txtConcepto.current.value = response.data[0].concepto;
              setDeshabilitado(true);
              //setHabiprov(false);
              txtMontoComprometer.current.value = "0,00";
              txtMontoFondo.current.value = formatMoneda(
                response.data.montoaenterar
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              setMonaCompro(response.data.montoaenterar);
              txtIdprov.current.value = response.data.idorganismo;
              seleccionarProveedor(response.data.idorganismo, 0);
              setDatospre(response.data);
              setMontoIva(0.0);
              //setIdPreComp(response.data[0].idprecompro);
              //Event evt = new Event();
              //evt.keyCode = SWT.CR;
              //txtIdCoordinacion.notifyListeners(SWT.KeyUp, evt);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              /* texto:
                "El Fondo en " +
                (tipo === 23 ? "Avance " : "Anticipo ") +
                "no existe", */
              texto: "La Solicitud de Compra no existe",
              icono: "informacion",
            });
            txtReferencia.current.value = "";
            txtReferencia.current.focus();
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarOrdenDonacion = (id) => {
    setActivate(true);
    let idval = "idordencompra";

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarordendonacion?idval=${idval}&id=${id}&idefiscal=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idordencompra > 0) {
          } else {
            txtReferencia.current.value = "";
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        txtReferencia.current.value = "";
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código del Compromiso no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtTipoCompromiso.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Tipo de Compromiso",
        icono: "informacion",
      });
      sigue = false;
      txtTipoCompromiso.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La fecha del compromiso no es valida",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if ( new Date(txtFecha.current.value).getFullYear() !== anioefis) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (
      txtIdprov.current.value.trim() === "" ||
      txtCedurifprov.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Proveedor",
        icono: "informacion",
      });
      sigue = false;
      txtIdprov.current.focus();
    } else if (txtIdCoordinacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Unidad Ejecutora",
        icono: "informacion",
      });
      sigue = false;
      txtIdCoordinacion.current.focus();
    } else if (txtConcepto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Decriba el Concepto o Detalle",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.focus();
    } else if (
      parseFloat(
        txtMontoComprometer.current.value.trim()
          .replace(/\./g, "").replace(",", ".")
      ) !== parseFloat(montoCompro)
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El monto total no debe ser menor que el monto a comprometer",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.focus();
    } else if (valida !== 1) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No existen cuentas presupuestaria para el compromiso",
        icono: "informacion",
      });
      sigue = false;
    } else if (
      props.operacion === 2 &&
      txtFechaReverso.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha de Reverso no es valida",
        icono: "informacion",
      });
      sigue = false;
      txtFechaReverso.current.focus();
    } else if (
      fechaRef !== null &&
      tipo !== 13 &&
      moment.utc(fechaRef).format("YYYY-MM-DD") > txtFecha.current.value
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "La Fecha del Compromiso no Puede ser Anterior a la Fecha de la Referecncia",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    }

    if (sigue) {
      let datoscomp = [];
      let datoscue = [];
      datoscomp.push({
        referencia: txtReferencia.current.value,
        idprove: txtIdprov.current.value,
        idcoordi: txtIdCoordinacion.current.value,
        concepto: txtConcepto.current.value,
        observ: txtObservacion.current.value,
        montocompro: montoCompro,
        montoiva: montoIva,
        tipopag: 0,
        fechareverso:
          props.operacion === 2 ? txtFechaReverso.current.value : null,
      });

      for (let i = 0; i < data.length; i++) {
        datoscue.push({
          m_nIdCta: data[i].idcuenta,
          m_cAux: data[i].auxiliar,
          m_nMonto: data[i].monto,
          m_nIdCatPro: data[i].idcat,
          m_nIdPuc: data[i].idpuc,
          m_nIdPreCompro: idPreComp,
          m_nIdMov: props.operacion === 1 ? 0 : data[i].idmovimiento,
        });
      }

      setBody({
        operacion: props.operacion,
        idcompro: txtCodigo.current.value,
        idefi: idefiscal,
        idusuario: idusuario,
        tipo: tipo,
        fecha: txtFecha.current.value,
        espiritu: espiritu,
        datoscompro: datoscomp,
        datoscuenta: datoscue,
      });

      let msg = "";
      setDesde(0);
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Reversar este Compromiso?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar este Compromiso?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/crearreversarcompromiso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            //setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Compromiso Registrado Correctamente', icono: 'exito' });
            setDesde(2);
            setMensajesino({
              mostrar: true,
              titulo: "Confirmación.",
              texto: "Desea Imprimir En este Momento el Compromiso?",
              icono: "confirmacion",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Compromiso " +
                txtCodigo.current.value +
                " Reversado Correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Compromiso " +
                txtCodigo.current.value +
                " Eliminado Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarModificarConcepto = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código del Compromiso no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (
      new Date(txtFecha.current.value).getFullYear() !== parseInt(anioefis)
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (
      fechaRef !== null &&
      tipo !== 13 &&
      moment.utc(fechaRef).format("YYYY-MM-DD") > txtFecha.current.value
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "La Fecha del Compromiso no Puede ser Anterior a la Fecha de la Referecncia",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtConcepto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Decriba el Concepto o Detalle",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.focus();
    }

    if (sigue) {
      let nomid = "";
      if (tipo === 26) {
        nomid = "idordendonacion";
      } else {
        nomid =
          espiritu == 8 ||
            espiritu == 9 ||
            espiritu == 12 ||
            espiritu == 14 ||
            espiritu == 15
            ? tipo === 5
              ? "idordencompra"
              : "idordenservicio"
            : "idordencompra";
      }
      let body = {
        idcompro: codigo,
        idcompronue: txtCodigo.current.value,
        concep: txtConcepto.current.value,
        dfecha: txtFecha.current.value,
        idefi: idefiscal,
        tipo: tipo,
        nomid: nomid,
        referencia: txtReferencia.current.value,
        idusu: idusuario,
        fechasis: fechaSistema,
        dirip: ip,
        dirmac: mac,
      };

      procesarCambio(body);
    }
  };

  const procesarCambio = (body) => {
    let endpoint = `${op.conexion}/api/presupuesto/modificarconceptocompromiso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Se Generaron Cambios Satisfactoriamente",
            icono: "exito",
          });
          setModifi(true);
          setProce(false);
          setHabiConcep(true);
          setHabiFecha(true);
          setHabicod(true);
          setCambioDatos(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarModificarFechaReverso = (fecha) => {
    //setDesde(1);
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: "Está Seguro de Cambiar la Fecha de Reverso del Compromiso?",
      icono: "confirmacion",
    });
  };

  const procesarCambioFechaReverso = () => {
    let body = {
      idcompro: txtCodigo.current.value,
      dfecha: fechaRev,
      idefi: idefiscal,
      idusu: idusuario,
      fechasis: fechaSistema,
      dirip: ip,
      dirmac: mac,
    };

    let endpoint = `${op.conexion}/api/presupuesto/modificarfechareversocompromiso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtFechaReverso.current.value = moment.utc(fechaRev).format("YYYY-MM-DD");
          setFecha(fechaRev);
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Se Generaron Cambios Satisfactoriamente",
            icono: "exito",
          });
          setCambioDatos(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    if (cambioDatos) {
      blanquear();
      props.onHideRenderizar();
      props.onHideCancelar();
    } else {
      blanquear();
      props.onHideCancelar();
    }
  };

  const imprimiCompromiso = () => {
    var reporte = "";
    /* if (espiritu === 9 || espiritu === 12) {
      reporte = "ForCompromisoAraure";
    } else if (espiritu === 14) {
      reporte = "ForCompromisoUnda";
    } else {
      reporte = "ForCompromiso";
    } */
    reporte = "ForCompromisoAraure";
    var sql = "";
    var sql2 = "1";
    if (tipo === 7) {
      sql2 = "0";
    }
    sql =
      "CPG.IdCompromiso=" +
      txtCodigo.current.value +
      " AND CPG.IDEFISCAL = " +
      idefiscal +
      " AND MXC.IDEFISCAL = " +
      idefiscal;
    var sql3 = " AND CPG.IDEFISCAL = " + idefiscal;
    var sql4 = " AND ORD.IDEFISCAL = " + idefiscal;
    var vali = props.operacion === 1 ? "0" : props.compro.reversado;
    var condicion = "";

    condicion = sql;
    window.open(
      op.reportes +
      "/contabilidadpresupuestaria?" +
      "reporte=" +
      reporte +
      "&CONDICION=" +
      condicion +
      "&DESCRIPTOR=" +
      sql2 +
      "&COMPROMISOEFIS=" +
      sql3 +
      "&ORDENEFIS=" +
      sql4 +
      "&USUARIO=" +
      liquidador.trim() +
      "&VIENE=" +
      espiritu +
      "&VALIDO=" +
      vali,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida(0);
    setVal(0.0);
    setMontoCompro(0.0);
    setCat(0);
    setProce(false);
    setModifi(false);
    setData([]);
    setBody(null);
    setCodigo(0);
    setValidat(0);
    setHabicat(true);
    setHabiProv(false);
    setHabiUni(false);
    setHabiConcep(false);
    setHabiFecha(false);
    setDeshabilitado(false);
    setIdPreComp(0);
    setHabicod(false);
    setCambioDatos(false);
    setFechaRef(null);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      procesarCambioFechaReverso();
    } else if (desde === 2) {
      imprimiCompromiso();
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto:
          "Compromiso " + txtCodigo.current.value + " Registrado Correctamente",
        icono: "exito",
      });
    } else if (desde === 3) {
      /*var reporte = '';
            if (espiritu === 9 || espiritu === 12 ){
                reporte = 'ForCompromisoAraure';	
            } else if (espiritu === 14) {
                reporte = 'ForCompromisoUnda';
            }else {
                reporte = 'ForCompromiso.jasper';
            }
            var sql = '';
            var sql2 = '1';
            if (tipo === 7) {
                sql2 = '0';
            }
            sql = 'CPG.IdCompromiso=' + txtCodigo.current.value + ' AND CPG.IDEFISCAL = ' + idefiscal + ' AND MXC.IDEFISCAL = ' + idefiscal;
            var sql3 = 'AND CPG.IDEFISCAL = ' + idefiscal;
            var vali = '0';
            var condicion = '';
           
            condicion = sql;
            window.open(op.reportes + "reporte=" + reporte + "&CONDICION=" + condicion + "&DESCRIPTOR=" + sql2 + "&ORDENEFIS=" + sql3 + "&USUARIO=" + liquidador.trim() + "&VIENE=" + espiritu + "&VALIDO=" + vali , "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");*/
      imprimiCompromiso();
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "Compromiso Registrado Correctamente",
        icono: "exito",
      });
    } else {
      Actualizar();
    }

    /*if (props.operacion === 1) {
            setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
            Actualizar();
        } else if (props.operacion === 2) {
            setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
            Actualizar();
        } else if (props.operacion === 3) {
            setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
            Actualizar();
        }*/
  };

  const handleCloseNo = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 2) {
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "Compromiso Registrado Correctamente",
        icono: "exito",
      });
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    //setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const BaseDatos = (data, moniva) => {
    if (props.operacion === 1) {
      if (data && data.length > 0) {
        setValida(1);
        setVt(1);
        let total = 0.0;
        for (let i = 0; i < data.length; i++) {
          total = parseFloat(total) + parseFloat(data[i].monto);
        }

        setMontoCompro(
          Math.round(parseFloat(total) * Math.pow(10, 4)) / Math.pow(10, 4)
        );
        if (tipo == 12 || tipo == 23 || props.operacion == 4 || tipo == 24) {
          txtMontoComprometer.current.value = formatMoneda(
            total.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
      }

      setMontoIva(
        Math.round(parseFloat(moniva) * Math.pow(10, 4)) / Math.pow(10, 4)
      );
    }
    setData(data);
  };

  const catalogoOrganismo = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const catalogoProveedor = (e) => {
    e.preventDefault();
    setMostrar4(true);
  };

  const catalogoReferencia = (e) => {
    e.preventDefault();
    if (validatipo === "1") {
      setMostrar5(true);
    } else if (validatipo === "2") {
      setMostrar8(true);
    } else if (validatipo === "3") {
      setMostrar5(true);
    } else if (validatipo === "5") {
      setMostrar6(true);
    } else if (validatipo === "6") {
      setCondicion("idefiscal = " + idefiscal + " AND tipofondo = 0");
      setMostrar7(true);
      //seleccionarFondoAvance(e.target.value);
    } else if (validatipo === "7") {
      setCondicion("idefiscal = " + idefiscal + " AND tipofondo = 1");
      setMostrar7(true);
      //seleccionarFondoAvance(e.target.value);
    } else if (validatipo === "9") {
      setMostrar5(true);
      //seleccionarOrdenDonacion(e.target.value);
    }
  };

  const handleCancelara = () => {
    setMostrar3(false);
  };

  const handleCancelaProveedor = () => {
    setMostrar4(false);
  };

  const handleCancelaOrdenes = () => {
    setMostrar5(false);
  };

  const handleCancelaObra = () => {
    setMostrar8(false);
  };

  const handleCancelaSpagosNomi = () => {
    setMostrar6(false);
  };

  const handleCancelaFondos = () => {
    setMostrar7(false);
  };

  const handleAceptaUnidadEjecutora = (
    idcoordinacion,
    nombre,
    iddireccion,
    encargado
  ) => {
    setMostrar3(false);

    txtIdCoordinacion.current.value = idcoordinacion;
    txtNombreUnidad.current.value = nombre.trim();
  };

  const handleAceptarProveedor = (
    responsable,
    razonsocial,
    idproveedor,
    rif
  ) => {
    setMostrar4(false);

    txtIdprov.current.value = idproveedor;
    seleccionarProveedor(idproveedor, 13);
    /*txtCedurifprov.current.value = rif;
        txtNombreprov.current.value = razonsocial.trim();*/
  };

  const handleAceptarOrdenes = (
    idcordinacion,
    concepto,
    idproveedor,
    idordencompra,
    idordenservicio,
    idordendonacion,
    fecha,
    observaciones,
    monto,
    montoiva,
    fechacrea
  ) => {
    if (tipo === 5) {
      txtReferencia.current.value = idordencompra;
    } else if (tipo === 11) {
      txtReferencia.current.value = idordenservicio;
    } else {
      txtReferencia.current.value = idordendonacion;
    }

    seleccionarOrdenCompra(txtReferencia.current.value, props.operacion, tipo);
    setMostrar5(false);
  };

  const handleAceptarObra = (
    idobraasignada,
    descripcionobra,
    razonsocial,
    idobra,
    idproveedor
  ) => {
    txtReferencia.current.value = idobra;

    seleccionarSolicitudPagoObra(txtReferencia.current.value, props.operacion);
    setMostrar8(false);
  };

  const handleAceptarSPagosNomi = (
    idsolicitudpagonomina,
    concepto,
    fechainicio
  ) => {
    txtReferencia.current.value = idsolicitudpagonomina;

    seleccionarSPagoNomina(txtReferencia.current.value, props.operacion);
    setMostrar6(false);
  };

  const handleAceptarFondos = (
    idfondo,
    descripcion,
    monto,
    responsable,
    tipofondo
  ) => {
    txtReferencia.current.value = idfondo;

    seleccionarFondoAvance(txtReferencia.current.value, props.operacion);
    setMostrar7(false);
  };

  const seleccionarProveedor = (codigo, tecla) => {
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idproveedor > 0) {
            txtIdprov.current.value = response.data.idproveedor;
            txtCedurifprov.current.value = response.data.rif;
            txtNombreprov.current.value = response.data.razonsocial;
            setExento(response.data.exentoiva);
            if (tecla === 13) {
              txtIdCoordinacion.current.focus();
            }
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleProveedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtCedurifprov.current.value = "";
    txtNombreprov.current.value = "";
    setDatospre([]);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProveedor(event.target.value, event.which);
      }
    }
  };

  const seleccionarUnidadEjecutora = (id) => {
    let endpoint = `${op.conexion}/api/presupuesto/consultarunidadejecutora?id=${id}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcoordinacion > 0) {
            txtIdCoordinacion.current.value = response.data.idcoordinacion;
            txtNombreUnidad.current.value = response.data.nombre;
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const handleUnidadEjecutora = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtNombreUnidad.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarUnidadEjecutora(event.target.value);
      }
    }
  };

  const seleccionaUltimoId = () => {
    let campos = "idcompromiso";
    let nomtab = "compromiso";
    let condi = "idefiscal=" + idefiscal;
    let orden = "idcompromiso DESC LIMIT 1";

    let endpoint =
      op.conexion +
      `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setUltimo(response.data[0].idcompromiso);
            setHabicod(false);
            txtCodigo.current.value =
              parseInt(response.data[0].idcompromiso) + 1;
          } else {
            setUltimo(1);
            setHabicod(false);
            txtCodigo.current.value = 1;
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "idcommpromiso") {
          txtTipoCompromiso.current.focus();
        } else if (event.target.id === "idprov") {
          if (txtCedurifprov.current.value.trim() !== "") {
            txtIdCoordinacion.current.focus();
          }
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const aceptaClaveSupervisor = () => {
    setMostrarUsuario(false);
    if (desde === 0) {
      setModifi(false);
      setProce(true);
      setHabiConcep(false);
      setHabiFecha(false);
      //setHabicod(false);
    } else if (desde === 1) {
      setLlamado(3);
      setFecha(txtFechaReverso.current.value);
      setCambiarDatos(true);
      //setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'El registro va a ser Modificado', icono: 'informacion' });
    }

    //imprimirRecibo(factura.idfactura);
  };

  const aceptaCambioDatos = (codigo, fecha, llamado) => {
    setCambiarDatos(false);
    setFechaRev(fecha);
    if (llamado === 3) {
      validarModificarFechaReverso();
    }

    //imprimirRecibo(factura.idfactura);
  };

  const cambiarConcepto = () => {
    setDesde(0);
    setMostrarUsuario(true);
  };

  const cambiarFechaReverso = () => {
    setDesde(1);
    setMostrarUsuario(true);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (
          props.operacion === 4 ||
          props.operacion === 3 ||
          props.operacion === 2
        ) {
          setHabicod(true);
        } else {
          setHabicod(false);
        }
        if (props.operacion === 4) {
          setModifi(true);

        }
        if (props.operacion !== 1) {
          setHabiFecha(true);
          setHabiConcep(true);
          setValues(props.compro);
          txtCodigo.current.value = props.compro.idcompromiso;
          setCodigo(props.compro.idcompromiso);
          txtMontoComprometer.current.value = formatMoneda(
            props.compro.montocompromiso
              .toString()
              .replace(",", "")
              .replace(".", ","),
            ",",
            ".",
            2
          );
          setMonaCompro(props.compro.montocompromiso);
          setMontoCompro(props.compro.montocompromiso);
          //setDatospre(props.movi);
          setTipo(props.compro.tipo);
          if (props.compro.tipo === 5) {
            txtTipoCompromiso.current.value = "1";
            setChek(1);
          } else if (props.compro.tipo === 7) {
            txtTipoCompromiso.current.value = "2";
            setChek(2);
          } else if (props.compro.tipo === 11) {
            txtTipoCompromiso.current.value = "3";
            setChek(3);
          } else if (props.compro.tipo === 12) {
            txtTipoCompromiso.current.value = "4";
            setChek(4);
          } else if (props.compro.tipo === 13) {
            txtTipoCompromiso.current.value = "5";
            setChek(5);
          } else if (props.compro.tipo === 23) {
            txtTipoCompromiso.current.value = "6";
            setChek(6);
          } else if (props.compro.tipo === 24) {
            txtTipoCompromiso.current.value = "7";
            setChek(7);
          } else if (props.compro.tipo === 25) {
            txtTipoCompromiso.current.value = "8";
            setChek(8);
          } else if (props.compro.tipo === 26) {
            txtTipoCompromiso.current.value = "9";
            setChek(9);
          }
          txtReferencia.current.value = props.compro.referencia;

          txtFecha.current.value = moment.utc(props.compro.fecha).format(
            "YYYY-MM-DD"
          );
          txtIdprov.current.value = props.compro.idproveedor;
          seleccionarProveedor(props.compro.idproveedor, 0);
          txtIdCoordinacion.current.value = props.compro.idcoordinacion;
          seleccionarUnidadEjecutora(props.compro.idcoordinacion);
          setDatospre(props.cuentas);
          //txtNombreOr.current.value = props.provee.razonsocial.trim();
          //txtNTraslado.current.value = '000' + props.compro.codigo;
          seleccionarReferencia(props.compro.tipo, props.operacion);

          if (props.cuentas.length > 0) {
            setValida(1);
            setValidat(1);
            setDeshabi(true);
          }
        } else {
          seleccionaUltimoId();
          txtTipoCompromiso.current.value = "1";
          setTipo(5);
          setValidatipo("1");
          setHabicatb(false);
          setHabicat(false);
          setEstatatus(1);
          setTipoOrden(0);
          setDeshabilitado(true);
          setHabiProv(true);
          setHabiUni(true);
          setHabiConcep(true);
          setHabiFecha(false);
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {props.titulo +
              (props.operacion === 1 && ultimo
                ? ", Ultimo procesado: " + ultimo
                : "")}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <div>
          <input type="hidden" ref={txtNp} />

          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul rounded row">
            <legend className="float-none m-0 w-auto">Datos</legend>

            {props.compro && props.compro.reversado > 0 && (
              <div className="col-sm-6">
                <div className="input-group input-group-sm m-0 w-100">
                  <font color="red" size="1">
                    <h1 align="center">
                      <i>¡ El Compromiso está Reversado !</i>
                    </h1>
                  </font>
                </div>
              </div>

            )}

            <div className="col-12 row m-0 d-flex justify-content-between">
              <div className="col-2 m-0 px-1">
                <Input
                  label="Código:"
                  onKeyUp={handleInputNumChange}
                  disabled={habiCod}
                  id="idcompromiso"
                  ref={txtCodigo}
                />
              </div>
              <div className="col-4 m-0 px-1">
                <Select
                  label="Tipo de Compromisos:"
                  onChange={onChange}
                  name="tipo"
                  disabled={
                    props.operacion === 4 ||
                      props.operacion === 3 ||
                      props.operacion === 2
                      ? true
                      : habitipoc
                  }
                  ref={txtTipoCompromiso}
                  options={[
                    { value: "", label: "--Seleccione--" },
                    { value: "1", label: "ORDEN DE COMPRA" },
                    { value: "2", label: "PAGO DE OBRAS/SERVICIOS" },
                    { value: "3", label: "ORDEN DE SERVICIO" },
                    { value: "4", label: "PAGO DIRECTO" },
                    { value: "5", label: "PAGO DE NOMINA" },
                    { value: "6", label: "FONDO EN AVANCE" },
                    { value: "7", label: "FONDO EN ANTICIPO" },
                    { value: "9", label: "ORDEN DE DONACIÓN" },
                  ]}
                />
                {/*<option value="8">CAJA CHICA</option>*/}
              </div>
              <div className="col-3 m-0 px-1">
                <SearchInput
                  label="N° de Referencia:"
                  autocomplete="off"
                  onKeyUp={handleReferencia}
                  onChange={onChange}
                  disabled={habicat}
                  name="referencia"
                  id="ref"
                  disabledButton={habicat}
                  onClickButton={catalogoReferencia}
                  ref={txtReferencia}
                />
              </div>
              {((props.operacion === 1 && chek === 6) || chek === 7) && (
                <div className="col-3 m-0 px-1">
                  <Input
                    label={
                      chek === 6 ? "Monto Fondo Avance:" : "Monto Fondo Anticipo:"
                    }
                    type="text"
                    className="form-control text-right"
                    disabled={true}
                    align="right"
                    ref={txtMontoFondo}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    id="motofondo"
                    defaultValue={"0,00"}
                  />
                </div>
              )}
            </div>
            <div className="col-12 row m-0 d-flex justify-content-around">
              <div className="col-2 m-0 px-1">
                <Input
                  label="Fecha:"
                  type="date"
                  disabled={habiFecha}
                  defaultValue={
                    props.compro && props.compro.fecha !== ""
                      ? moment.utc(props.compro.fecha).format("YYYY-MM-DD")
                      : moment.utc(fechaSistema).format("YYYY-MM-DD")
                  }
                  id="inputDireccion"
                  ref={txtFecha}
                />
              </div>

              {((props.compro && props.compro.reversado > 0) ||
                props.operacion === 2) && (
                  <div className="col-3 m-0 px-1">
                    <Input
                      label="Fecha Reverso:"
                      type="date"
                      disabled={props.operacion === 2 ? false : true}
                      defaultValue={
                        props.compro &&
                          props.compro.fechareverso !== "" &&
                          props.compro.fechareverso !== null
                          ? moment.utc(props.compro.fechareverso).format("YYYY-MM-DD")
                          : moment.utc(fechaSistema).format("YYYY-MM-DD")
                      }
                      id="inputDireccion"
                      ref={txtFechaReverso}
                    />
                  </div>
                )}
              <div className="col-3 m-0 ml-auto p-0 pl-3">
                <Input
                  label="Monto a Comprometer:"
                  disabled={true}
                  align="right"
                  id="mobtoComprometer"
                  defaultValue={"0,00"}
                  ref={txtMontoComprometer}
                />
              </div>
            </div>
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none m-0 w-auto">Beneficiario</legend>
              <div className="col-2 m-0 p-0">
                <SearchInput
                  label="Código:"
                  autocomplete="off"
                  onChange={handleProveedor}
                  onKeyUp={handleInputNumChange}
                  disabled={
                    props.operacion === 4 ||
                      props.operacion === 3 ||
                      props.operacion === 2
                      ? true
                      : habiProv
                  }
                  id="idprov"
                  disabledButton={
                    props.operacion === 4 ||
                      props.operacion === 3 ||
                      props.operacion === 2
                      ? true
                      : habiProv
                  }
                  onClickButton={catalogoProveedor}
                  ref={txtIdprov}
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input
                  label="RIF:"
                  className="form-control text-uppercase"
                  maxLength={12}
                  disabled={true}
                  id="inputDireccion"
                  ref={txtCedurifprov}
                />
              </div>
              <div className="col-8 m-0 p-0 pl-2">
                <Input
                  label="Nombre:"
                  type="text"
                  disabled={true}
                  id="inputDireccion"
                  ref={txtNombreprov}
                />
              </div>
            </fieldset>

            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none m-0 w-auto">
                Unidad Ejecutora
              </legend>
              <div className="col-2 m-0 p-0">
                <SearchInput
                  label="Código:"
                  autocomplete="off"
                  onChange={handleUnidadEjecutora}
                  disabled={
                    props.operacion === 4 ||
                      props.operacion === 3 ||
                      props.operacion === 2
                      ? true
                      : habiUni
                  }
                  id="inputDireccion"
                  disabledButton={
                    props.operacion === 4 ||
                      props.operacion === 3 ||
                      props.operacion === 2
                      ? true
                      : habiUni
                  }
                  onClickButton={catalogoOrganismo}
                  ref={txtIdCoordinacion}
                />
              </div>
              <div className="col-10 m-0 p-0 pl-2">
                <Input
                  label="Nombre:"
                  disabled={true}
                  id="inputDireccion"
                  ref={txtNombreUnidad}
                />
              </div>
            </fieldset>

            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <div className="col-6 m-0 p-0 pr-2">
                <Textarea
                  label="Concepto/Detalles:"
                  style={{ height: 70 }}
                  name="concepto"
                  onChange={onChange}
                  disabled={habiConcep}
                  defaultValue={
                    props.compro ? props.compro.concepto.trim() : ""
                  }
                  placeholder="Describa el Concepto o Detalle"
                  id="inputDireccion"
                  ref={txtConcepto}
                />
              </div>
              <div className="col-1 m-0 p-0">
                {modifi === true && (
                  <WarningButton
                    onClick={cambiarConcepto}
                    icon="fa-edit"
                  ></WarningButton>
                )}
                {proce === true && (
                  <SuccessButton
                    onClick={validarModificarConcepto}
                  ></SuccessButton>
                )}
              </div>

              <div className="col-5 m-0 p-0">
                <Textarea label='Observaciones:'
                  style={{ height: 70 }}
                  name="observacion"
                  onChange={onChange}
                  disabled={
                    props.operacion === 4 ||
                      props.operacion === 3 ||
                      props.operacion === 2
                      ? true
                      : deshabilitado
                  }
                  defaultValue={
                    props.compro ? props.compro.observacion.trim() : ""
                  }
                  placeholder="Describa la Observación"
                  id="inputDireccion"
                  ref={txtObservacion}
                />
              </div>
            </fieldset>
          </fieldset>

          <fieldset className="row border-azul rounded mx-auto">
            <legend className="float-none m-0  w-auto">Codificación</legend>

            <div className="col-md-12 px-0">
              <TablaCodificacion
                data={BaseDatos}
                datarecords={datospre}
                operacion={props.operacion}
                validaboton={deshabi}
                tipo={tipo}
                exento={exento}
                idprov={txtIdprov.current ? txtIdprov.current.value : ""}
                nmonacompro={monaCompro}
              />
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
          disabled={props.operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
        {props.compro && props.operacion !== 1 && (
          <PrimaryButton onClick={imprimiCompromiso} icon="fa-print">
            Imprimir
          </PrimaryButton>
        )}

        {props.compro &&
          props.operacion === 4 &&
          props.compro.reversado > 0 && (
            <WarningButton onClick={cambiarFechaReverso} icon="fa-edit">
              Editar Fecha Reverso
            </WarningButton>
          )}
      </Modal.Footer>
      <CatalogoUnidadEjecutora
        show={mostrar3}
        onHideCancelar={handleCancelara}
        onHideAceptarUnidad={handleAceptaUnidadEjecutora}
      />
      <CatalogoProveedorPresupuesto
        show={mostrar4}
        onHideCancelar={handleCancelaProveedor}
        onHideAceptaProveedor={handleAceptarProveedor}
      />
      <CatalogoOrdenesdeComprasAprob
        show={mostrar5}
        status={estatus}
        tipo={tipoOrden}
        onHideCancelar={handleCancelaOrdenes}
        onHideAceptaOrdenes={handleAceptarOrdenes}
      />
      <CatalogoObrasAsignada
        show={mostrar8}
        status={0}
        onHideCancelar={handleCancelaObra}
        onHideAceptaObra={handleAceptarObra}
      />
      <CatalogoSPagoNomiAprob
        show={mostrar6}
        status={0}
        onHideCancelar={handleCancelaSpagosNomi}
        onHideAceptaSolicitudes={handleAceptarSPagosNomi}
      />
      <CatalogoFondoAvanceAprob
        show={mostrar7}
        condicion={condicion}
        onHideCancelar={handleCancelaFondos}
        onHideAceptaFondos={handleAceptarFondos}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito." || mensaje.titulo === "Notificación."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={handleCloseNo}
        onHideSi={handleCloseSi}
      />
      <ValidarUsuario
        show={mostrarUsuario}
        onHideCancela={() => {
          setMostrarUsuario(false);
        }}
        onHideConfirmar={aceptaClaveSupervisor}
        llamado={2}
      />
      <CambiodeDatos
        show={cambiarDatos}
        onHideCancela={() => {
          setCambiarDatos(false);
        }}
        onHideConfirmar={aceptaCambioDatos}
        llamado={llamado}
        codigo={txtCodigo.current ? txtCodigo.current.value : ""}
        fecha={fecha}
        fechad={txtFecha.current ? txtFecha.current.value : ""}
        validarfechad={true}
      />
    </Modal>
  );
};
